(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll(
    '[data-features-section]'
  );

  if (!sections.length) return;


  /* =====================================================
     INTERSECTION OBSERVER
  ===================================================== */

  const observer = new IntersectionObserver(
    function (entries) {

      entries.forEach(function (entry) {

        if (entry.isIntersecting) {

          entry.target.classList.add('is-visible');

          /*
           * Animate only once.
           */

          observer.unobserve(entry.target);

        }

      });

    },
    {
      threshold: 0.18,

      rootMargin: '0px 0px -8% 0px'
    }
  );


  sections.forEach(function (section) {

    observer.observe(section);

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ride-feature"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll('[data-ride-feature]');

  if (!sections.length) return;


  /*
   * Intersection Observer
   *
   * Animation starts when the section enters the viewport.
   */

  const observer = new IntersectionObserver(
    function (entries) {

      entries.forEach(function (entry) {

        if (entry.isIntersecting) {

          entry.target.classList.add('is-visible');

          /*
           * Animate only once.
           */

          observer.unobserve(entry.target);

        }

      });

    },
    {
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px'
    }
  );


  sections.forEach(function (section) {

    observer.observe(section);

  });

});


  } catch(e) { console.error(e); }
})();
})();
